
/**
 * 
 * @param {*} key 
 * @param {*} value 
 */

import Cookie from 'js-cookie'
import {isNullOrUndefined} from 'util'


Cookie.defaults.expires=10;

const isNullOrEmpty = obj =>  isNullOrUndefined(obj) || (isArray(obj) ? obj.length == 0 : false);

// const set = (key, value) => Cookie.set(key, JSON.stringify(value));
const set = (key, value) => localStorage.setItem(key, JSON.stringify(value));

// const clear = () => Cookie.clear();
const clear = () => localStorage.clear();

const get = key => {
    // let str = Cookie.get(key);
    let str = localStorage.getItem(key);
    try {
        return str === undefined ? undefined : JSON.parse(str);
    } catch (e) {
        console.error(`数据存储有错误，无法转换.异常数据:${key}`);
        console.error(str);
        return undefined;
    }
}

const has = key => isNullOrEmpty(get(key));

// const remove = (key) => Cookie.remove(key);
const remove = (key) => localStorage.removeItem(key);

const cookie = {
    set,get,clear,has,remove
}

export default cookie;